import api from 'base/utils/api';
import { IBlackFridayCheckInData } from 'base/interfacesV2/blackFriday';
import type { GetServerSidePropsContext } from 'next';

/**
 * 2023黑五签到活动数据
 */
export function getBlackFriday2023CheckInProgress(): Promise<IBlackFridayCheckInData> {
    return api.post('/web/activity/getBlackFriday2023CheckInProgress')
}

/**
 * 2023黑五 签到
 */
export function blackFriday2023CheckIn(): Promise<IBlackFridayCheckInData> {
    return api.post('/web/activity/blackFriday2023CheckIn')
}

export async function getServerSideProps(data: GetServerSidePropsContext) {
    const blackFridayCheckInProgressData = await getBlackFriday2023CheckInProgress()

    return {
        props: {
            blackFridayCheckInProgressData
        }
    }
}